import React, {useMemo} from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";

const EMPTY_VALUE = "";

const texturePreviewUrl = (row) =>
    row?.relativeUrlSmall || row?.relativeUrl || null;

const TexturePreviewThumb = ({url, size = 56, sx = {}}) => (
    <Box
        role="img"
        aria-hidden={!url}
        sx={{
            flexShrink: 0,
            width: size,
            height: size,
            borderRadius: "8px",
            backgroundImage: url ? `url(${url})` : "none",
            backgroundColor: url ? "transparent" : "#EAEBEA",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            border: "1px solid",
            borderColor: "divider",
            ...sx,
        }}
    />
);

/**
 * Выбор текстуры композиции (справочник «Текстуры») — сохранение через PATCH set-texture снаружи.
 */
export default function CompositionMainTextureSelect({
    label,
    textureIdField,
    value,
    options = [],
    disabled = false,
    loading = false,
    onChange,
}) {
    const normalizedValue = value == null || value === "" ? EMPTY_VALUE : String(value);

    const selectedRow = useMemo(
        () => options.find((row) => String(row.id) === normalizedValue),
        [options, normalizedValue],
    );
    const selectedPreviewUrl = texturePreviewUrl(selectedRow);

    return (
        <Box sx={{display: "flex", alignItems: "flex-start", gap: "12px", width: "100%"}}>
            <TextFieldValidation
                select
                label={label}
                name={textureIdField}
                value={normalizedValue}
                width="328px"
                required={false}
                disabled={disabled || loading}
                inputLabelProps={{shrink: true}}
                selectProps={{
                    renderValue: (selected) => {
                        if (selected === EMPTY_VALUE) {
                            return "";
                        }
                        const match = options.find((row) => String(row.id) === String(selected));
                        return match?.name || `Текстура #${selected}`;
                    },
                }}
                setCurrValues={(updater) => {
                    const next = updater({});
                    const raw = next?.[textureIdField];
                    if (raw === EMPTY_VALUE || raw == null || raw === "") {
                        onChange?.(null);
                        return;
                    }
                    onChange?.(Number(raw));
                }}
            >
                <MenuItem value={EMPTY_VALUE}>
                    Не выбрано
                </MenuItem>
                {options.map((row) => {
                    const previewUrl = texturePreviewUrl(row);
                    return (
                        <MenuItem key={row.id} value={String(row.id)}>
                            <Box sx={{display: "flex", alignItems: "center", gap: "12px", minWidth: 0}}>
                                <TexturePreviewThumb url={previewUrl} size={40}/>
                                <Box component="span" sx={{overflow: "hidden", textOverflow: "ellipsis"}}>
                                    {row.name || `Текстура #${row.id}`}
                                </Box>
                            </Box>
                        </MenuItem>
                    );
                })}
            </TextFieldValidation>
            <TexturePreviewThumb
                url={selectedPreviewUrl}
                size={56}
                sx={{marginTop: "8px"}}
            />
        </Box>
    );
}
